import {gettext} from 'topmeteo/utils/i18n';

import Body from './Body';

const Headline = gettext('Shopping basket');

const Basket = props => (
    <div className="shopping-basket">
        <h2>{Headline} <i className="icon icon-link" /></h2>
        <div className="table-wrapper">
            <table className="shopping-basket-table">
                <Body {...props} />
            </table>
        </div>
    </div>
);

export default Basket;
